import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import config from 'client/shared/config';

import SongListHeadings from './song-list-headings';
import SongRow from './song-row';

@inject('songsStore', 'membersBFFStore')
@observer
class SongList extends Component {
	render () {
		const { songsStore, songList, optionsTheme } = this.props;

		if (_.isEmpty(songList)) {

			return null;
		}

		return (
			<div className="song-list" data-ta="song-list">
				<SongListHeadings trackListMode />

				{
					songList.map(
						(song, index) =>
							<SongRow
								trackListMode
								optionsTheme={ optionsTheme }
								key={ song.id }
								index={ index }
								song={ song }
								songID={ song.id }
								playAction={ () => this.onPlayClick(songList, index) }
								songsStore={ songsStore } />
					)
				}
			</div>
		);
	}

	@autobind
	onPlayClick (newList, songIndex){
		const { membersBFFStore, artist: { user, name } } = this.props;
		const { paths: { profileImgBasePath } } = config;
		const imagePath = `${profileImgBasePath}/${user.profileImage}`;

		let list = [...newList];
		list.splice(0,songIndex);

		membersBFFStore.setCurrentPlaylist({
			list, name, imagePath
		});

		sessionStorage.setItem("scrollPosition", window.pageYOffset);
	}
}

export default SongList;
